import React, { useState } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import CircularProgress from "@material-ui/core/CircularProgress";
import PasswordInput from "../elements/passwordInput/PasswordInput";
import DefaultButton from "../styles/materialButtonStyle";
import ValidationFormControl from "../styles/materialValidFormControl";
import axios from "axios";
import basicAuthenticationConfig from "../../utils/basicAuthenticationConfig";

import { StyledForm, StyledFormAction, StyledFormContent } from "../styles/styledForm";
import { parseAxiosError } from "../../utils/response";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../utils/consts";

const LoginForm = ({ onPasswordAccepted, onTokenIssued, notification, setNotification, t }) => {

  const [loading, setLoading] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    const authConfig = basicAuthenticationConfig(event.target.email.value.trim(), event.target.password.value);

    setLoading(true);

    axios.post("/api", {}, authConfig).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        onPasswordAccepted(authConfig);
      }
      if (response.status === HTTP_STATUSES.HTTP_CREATED) {
        onTokenIssued(response.data.data.attributes.token);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => {
      setLoading(false);
    });
  };

  return (
    <StyledForm
      onSubmit={handleSubmit}
      className="login-form"
    >
      <StyledFormContent className="login-form__content">
        <ValidationFormControl className="login-form__input">
          <InputLabel htmlFor="eMail">E-mail</InputLabel>
          <Input
            id="eMail"
            required
            type="email"
            name="email"
            autoComplete="email"
          />
        </ValidationFormControl>
        <PasswordInput
          label={t("loginPassword")}
          id="password"
          className="login-form__input"
        />
      </StyledFormContent>
      <StyledFormAction className="login-form__action">
        <DefaultButton
          color="success"
          type="submit"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={18} color="inherit"/> : null}
        >
          {t("loginSubmit")}
        </DefaultButton>
        <p className="login-form__hint">
          {t("noSelfServiceReset")}
        </p>
      </StyledFormAction>
    </StyledForm>
  );
};

export default LoginForm;
